export default "__VITE_ASSET__62468d56__"